import { FiPlus } from "react-icons/fi";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { Button } from "flowbite-react";

const ButtonAdd = (props) => {
  const tmpProps = {
    ...props,
    theme: tenkenTheme.button,
    color: "primary",
    className: `rounded-[6px] min-w-[140px] lg:h-10 h-[38px] ${props.className}`,
  };
  return (
    <Button {...tmpProps}>
      <FiPlus className="mr-1 lg:h-5 lg:w-5 h-[18px] w-[18px]" />
      {props.children}
    </Button>
  );
};

export default ButtonAdd;
